export const FETCH_SUCCESS = "SETTINGS_USERS/FETCH_SUCCESS";
export const TABLE_UPDATE = "SETTINGS_USERS/TABLE_UPDATE";

const types = {
    FETCH_SUCCESS,
    FETCH_FAILED: "SETTINGS_USERS/FETCH_FAILED",
    FETCH_REQUEST: "SETTINGS_USERS/FETCH_REQUEST",

    UPDATE_FAILED: "SETTINGS_USERS/UPDATE_FAILED",
    UPDATE_REQUEST: "SETTINGS_USERS/UPDATE_REQUEST",
    UPDATE_SUCCESS: "SETTINGS_USERS/UPDATE_SUCCESS",

    CREATE_REQUEST: "SETTINGS_USERS/CREATE_REQUEST",
    CREATE_SUCCESS: "SETTINGS_USERS/CREATE_SUCCESS",
    CREATE_FAILED: "SETTINGS_USERS/CREATE_FAILED",

    EMAIL_REQUEST: "SETTINGS_USERS/EMAIL_REQUEST",
    EMAIL_SUCCESS: "SETTINGS_USERS/EMAIL_SUCCESS",
    EMAIL_FAILED: "SETTINGS_USERS/EMAIL_FAILED",

    DELETE_REQUEST: "SETTINGS_USERS/DELETE_REQUEST",
    DELETE_SUCCESS: "SETTINGS_USERS/DELETE_SUCCESS",
    DELETE_FAILED: "SETTINGS_USERS/DELETE_FAILED",

    GET_FAILED: "SETTINGS_USERS/GET_FAILED",
    GET_REQUEST: "SETTINGS_USERS/GET_REQUEST",
    GET_SUCCESS: "SETTINGS_USERS/GET_SUCCESS",

    TABLE_UPDATE,
};

export default types;
